import {
  formatMoney,
  useClientConsolidation,
  usePrivacyText,
} from '@itarget/shared'
import { useConsolidationTranslation } from './translation'

export const useConsolidation = () => {
  const { getPrivacyText } = usePrivacyText()

  const translation = useConsolidationTranslation()

  const { getConsolidation, isConsolidationLoaded } = useClientConsolidation()

  const { toReceive, ToExpire, Expired, notToExpire, symbol } =
    getConsolidation()

  const convertAmountToPrivacyReal = (amount = 0) => {
    return getPrivacyText(formatMoney.toReal(amount))
  }

  const consolidationCollection = [
    {
      key: 'consolidation-cash-toReceive',
      value: convertAmountToPrivacyReal(toReceive),
      type: translation.toReceive,
      description: translation.toReceiveLabel,
      model: translation.cashback,
    },
    {
      key: 'consolidation-cash-ToExpire',
      value: convertAmountToPrivacyReal(ToExpire),
      type: translation.ToExpire,
      description: translation.ToExpireLabel,
      model: translation.cashback,
    },
    {
      key: 'consolidation-cash-Expired',
      value: convertAmountToPrivacyReal(Expired),
      type: translation.Expired,
      description: translation.ExpiredLabel,
      model: translation.cashback,
    },
    {
      key: 'consolidation-cash-notToExpire',
      value: convertAmountToPrivacyReal(notToExpire),
      type: translation.notToExpire,
      description: translation.notToExpireLabel,
      model: translation.cashback,
    },
  ]

  return {
    cashbackSymbol: symbol,
    consolidationCollection,
    isConsolidationLoaded,
  }
}
